import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SpecificationsModalStylesClasses = 'title';

const specificationsModalStyles = makeStyles<ISpcTheme, SpecificationsModalStylesClasses>(
  theme => ({
    title: {
      fontSize: theme.typography.fontXL,
      paddingLeft: 8,

      [theme.breakpoints.down('xs')]: {
        textAlign: 'left',
        fontSize: theme.typography.fontLG,
      },
    },
  }),
  { name: 'Customise_SpecificationsModalStyles' },
);

export default specificationsModalStyles;
